import React, { useState, useRef, useEffect } from 'react';
import { FlexGridColumn } from '@grapecity/wijmo.react.grid';
import * as wjInput from '@grapecity/wijmo.react.input';
import { Button } from 'react-bootstrap';
import CommonGrid from '@components/CommonGrid';
import '@css/company-select-modal.css';

export default function CompanySelectModal({ show, companies, btnClick }) {

    const popupRef = useRef(null);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        const popup = popupRef.current?.control;
        if (!popup) return;

        const handler = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        popup.hostElement?.addEventListener('keydown', handler, true);

        return () => {
            popup.hostElement?.removeEventListener('keydown', handler, true);
        };
    }, []);

    useEffect(() => {
        const popup = popupRef.current?.control;
        if (!popup) return;

        if (show && !popup.isVisible) {
            popup.show(true);
        }

        if (!show && popup.isVisible) {
            popup.hide();
        }

    }, [show]);

    return (
        <wjInput.Popup ref={popupRef} modal={true} isDraggable={true} hideTrigger={0} isResizable={true}
        >
            <div className="wj-dialog-header">업체 선택</div>
            <div className="cs-modal-body">
                <CommonGrid
                    showMarquee={true}
                    className="cs-modal-grid"
                    itemsSource={companies}
                    selectionMode="Row"
                    isReadOnly={true}
                    initialized={(grid) => {
                        grid.selectionChanged.addHandler(() => {
                            setSelectedItem(grid.selectedItems[0]);
                        });
                    }}
                >
                    <FlexGridColumn header="업체코드" binding="companyCode" />
                    <FlexGridColumn header="업체명" binding="companyName" />
                </CommonGrid>
            </div>
            <div className="cs-modal-footer">
                <Button
                    style={{ width: '100%', height: '50px' }}
                    variant="primary"
                    onClick={() => {
                        btnClick(selectedItem.companyCode);
                    }}
                    disabled={!selectedItem}
                >
                    선택
                </Button>
            </div>
        </wjInput.Popup>
    );
}
